import React, { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { EyeIcon, EyeOffIcon, LoaderIcon } from "lucide-react";
import { useSeo } from "../../hooks/useSeo";
import { AuthShell } from "../../components/client/AuthShell";
import { Field, inputCls } from "../../components/forms/Field";
import { CONTACT } from "../../data/site";
export function ClientLogin() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  useSeo({
    title: "Client Login",
    description: "Sign in to your NEXORA client dashboard.",
    path: "/client-login",
    noindex: true
  });
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    window.setTimeout(() => navigate("/client-dashboard"), 400);
  };
  return <AuthShell eyebrow="Client area" title="Welcome back." lead="Track your project, download files, view invoices and request changes — all in one place." footer={<>New client? <Link to="/register" className="text-fg underline underline-offset-4" data-id="element-629" data-mp="3544f7zxgwqzm">Create an account</Link></>} data-id="element-628" data-mp="26cdetmexl0lv">
      <form onSubmit={onSubmit} className="grid gap-5" data-id="element-630" data-mp="3a2xpzklde3w3">
        <h2 className="t-h3" data-id="element-631" data-mp="3e63w8s8hfv2k">Client login</h2>
        <Field label="Email" htmlFor="login-email" data-id="element-632" data-mp="3e6dnej59k89u"><input id="login-email" type="email" required autoComplete="email" className={inputCls} data-id="element-633" data-mp="3j4ym2e4vajw6" /></Field>
        <Field label="Password" htmlFor="login-password" data-id="element-634" data-mp="2mey1ysfg0rl7">
          <div className="relative" data-id="element-635" data-mp="2mgiygnlbiklp">
            <input id="login-password" type={show ? "text" : "password"} required autoComplete="current-password" className={`${inputCls} pr-14`} data-id="element-636" data-mp="2qg04pj8kjlrx" />
            <button type="button" onClick={() => setShow(!show)} aria-label={show ? "Hide password" : "Show password"} className="absolute right-1.5 top-1/2 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-lg text-muted hover:text-fg" data-id="element-637" data-mp="2vdt8y6qba5pk">
              {show ? <EyeOffIcon className="h-5 w-5" data-id="element-638" data-mp="27pif3nj196as" /> : <EyeIcon className="h-5 w-5" data-id="element-639" data-mp="27oh23digi9qf" />}
            </button>
          </div>
        </Field>
        <a href={`mailto:${CONTACT.email}?subject=Password%20reset`} className="justify-self-start text-[15px] text-fg-2 underline underline-offset-4 hover:text-fg" data-id="element-640" data-mp="3azeexh3x4joa">Forgot password?</a>
        <button type="submit" disabled={loading} className="inline-flex min-h-[54px] items-center justify-center gap-2 rounded-full bg-accent font-medium text-white transition-colors duration-150 ease-out hover:bg-accent-bright disabled:opacity-70" data-id="element-641" data-mp="3jt99jv7eyrpo">
          {loading ? <><LoaderIcon className="h-4 w-4 animate-spin" data-id="element-642" data-mp="2n2qioixpb2sj" />Signing in…</> : "Sign in"}
        </button>
      </form>
    </AuthShell>;
}